// Android-приложение (APK, Trusted Web Activity): приложение открывает игру по ссылке
// https://kings-of-seas.ru/?app=android&v=<versionCode>&store=site|play. Версию и канал запоминаем
// на время сессии вкладки приложения: TWA делит хранилище с Chrome, и localStorage «заразил» бы обычный
// браузер (там пропала бы ссылка на APK и появилось бы окно обновления).
import { nativeBridge } from './native';

const KEY = 'sk_android_app_v';
const STORE_KEY = 'sk_android_app_store';
export const APK_URL = '/download/kings-of-seas.apk';
export const PLAY_URL = 'https://play.google.com/store/apps/details?id=ru.kingsofseas.game';
export const RUSTORE_URL = 'https://www.rustore.ru/catalog/app/ru.kingsofseas.game';
/** Откуда установлено приложение: с сайта (APK), из Google Play или из RuStore. */
export type AndroidStore = 'site' | 'play' | 'rustore';

function storage(): Storage | null {
  try {
    return sessionStorage;
  } catch {
    return null;
  }
}

/** Вызывается при старте: если игра открыта из приложения — запомнить его версию и канал. */
export function detectAndroidApp(): void {
  const params = new URLSearchParams(window.location.search);
  const v = Number(params.get('v'));
  try {
    localStorage.removeItem(KEY); // старые сборки хранили версию здесь
  } catch {
    // нет хранилища
  }
  if (params.get('app') === 'android' && Number.isInteger(v) && v > 0) {
    storage()?.setItem(KEY, String(v));
    storage()?.setItem(STORE_KEY, params.get('store') === 'play' ? 'play' : 'site');
  } else if (document.referrer.startsWith('android-app://ru.kingsofseas.game')) {
    if (!storage()?.getItem(KEY)) storage()?.setItem(KEY, '1');
  }
}

/** Канал установки приложения (имеет смысл, только если androidAppVersion() не null). */
export function androidAppStore(): AndroidStore {
  // Приложение с игрой внутри APK сообщает канал само
  const bridge = nativeBridge();
  if (bridge) return bridge.store() === 'rustore' ? 'rustore' : 'site';
  return storage()?.getItem(STORE_KEY) === 'play' ? 'play' : 'site';
}

/** Версия установленного приложения (versionCode) или null — игра открыта в обычном браузере. */
export function androidAppVersion(): number | null {
  const bridge = nativeBridge();
  if (bridge) return bridge.versionCode();
  const v = Number(storage()?.getItem(KEY));
  return Number.isInteger(v) && v > 0 ? v : null;
}

/** Показывать ли ссылку «Скачать приложение»: не внутри приложения и не на iPhone/iPad. */
export function canOfferApk(): boolean {
  if (androidAppVersion()) return false;
  return !/iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export interface AndroidAppInfo {
  available: boolean;
  versionCode?: number;
  versionName?: string;
  minVersionCode?: number;
  url?: string;
  size?: number;
  notes?: string;
  publishedAt?: string;
}
